<template>
  <v-card
    :to="to"
    class="mx-auto tour-card"
  >
    <template slot="progress">
      <v-progress-linear
        color="deep-purple"
        height="10"
        indeterminate
      ></v-progress-linear>
    </template>
    <v-img
      :src="image"
      class="white--text align-end"
      gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
      height="200px"
    >
      <v-card-title class="pt-0">{{ name }}</v-card-title>
    </v-img>
    <v-chip v-if="publish" class="tour-card__chip us-n" color="primary" small>
      Published
    </v-chip>

    <div class="tour-card__menu">
      <v-menu offset-y left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn small
                 icon
                 color="white"
                 v-bind="attrs" v-on="on" v-on:click.prevent>
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list dense nav>
          <!--
          <v-list-item @click="$emit('on-edit')">
            <v-list-item-icon><v-icon>mdi-file-edit-outline</v-icon></v-list-item-icon>
            <v-list-item-title>Edit</v-list-item-title>
          </v-list-item>
          -->
          <v-list-item @click="$emit('on-remove')" class="v-menu--red">
            <v-list-item-icon><v-icon>mdi-delete-outline</v-icon></v-list-item-icon>
            <v-list-item-title>Remove</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'TourCard',
  props: {
    to: Object,
    name: String,
    image: String,
    description: String,
    views: Number,
    publish: Boolean
  }
}
</script>

<style scoped lang="scss">
.tour-card {
  box-shadow: 0 12px 50px 2px #13507c24 !important;
  height: 100%;
  transition: all .3s ease;
  overflow: hidden;

  &:hover {
    text-decoration: none;
  }

  &__chip {
    position: absolute;
    top: 10px;
    left: 10px;
  }

  &__menu {
    position: absolute;
    top: 8px;
    right: 10px;
  }
}
</style>
